/**
 * Created by neo on 23.08.21.
 */
import { v4 as UUID } from 'uuid';
import { makeAutoObservable } from 'mobx';
import { ProgramTemplateProgramParams, createProgramTemplateProgramParams } from '../ProgramTemplateProgramParams';

export type WorkoutDayEntry = {
  id: string;
  includedTags: string[];
  excludedTags: string[];
  workoutTemplateId: string;
  params?: ProgramTemplateProgramParams;
  minWorkoutDurationInMinutes?: number;
  maxWorkoutDurationInMinutes?: number;
  matches(tags?: string[]): boolean;
  matchCount(tags: string[]): number;
  toJS(newId?: boolean): Partial<WorkoutDayEntry>;
};

export function createWorkoutDayEntry(json?: Partial<WorkoutDayEntry>): WorkoutDayEntry {
  const entry: WorkoutDayEntry = makeAutoObservable({
    id: json?.id ?? UUID(),
    includedTags: json?.includedTags ?? [],
    excludedTags: json?.excludedTags ?? [],
    workoutTemplateId: json?.workoutTemplateId ?? '',
    params: json?.params ? createProgramTemplateProgramParams(json.params) : undefined,
    minWorkoutDurationInMinutes: json?.minWorkoutDurationInMinutes,
    maxWorkoutDurationInMinutes: json?.maxWorkoutDurationInMinutes,

    matches(tags?: string[]): boolean {
      if (tags) {
        return (
          (this.includedTags.length === 0 || this.includedTags.every((t) => tags.indexOf(t) !== -1)) &&
          !tags.some((t) => this.excludedTags.indexOf(t) !== -1)
        );
      }
      return true;
    },

    matchCount(tags: string[]): number {
      return this.includedTags.filter((v) => tags.includes(v)).length;
    },

    toJS(newId: boolean = false): Partial<WorkoutDayEntry> {
      return {
        id: newId ? UUID() : this.id,
        includedTags: this.includedTags.slice(),
        excludedTags: this.excludedTags.slice(),
        workoutTemplateId: this.workoutTemplateId,
        params: this.params,
        minWorkoutDurationInMinutes: this.minWorkoutDurationInMinutes,
        maxWorkoutDurationInMinutes: this.maxWorkoutDurationInMinutes,
      };
    },
  });
  return entry;
}
